import Api from '../../../../../../../shared/Api';
import { ImageModel, ImageUploadResponse } from '../../../shared/types';
import { CustomerOrSupportImage } from "../view/UploadUneditedImages";

function transformFormDataToFileList(data: FormData): string[] {
    return data.get('files').toString().split(',');
}

export class UneditedImagesApi {
    static getImages(orderId: number): Promise<ImageModel> {
        return new Api().get(`/views/digital-styling-upload/${orderId}/unedited`);
    }

    static saveMetadata(data: FormData): Promise<any> {
        let orderId = data.get('orderId');
        let files = transformFormDataToFileList(data);

        return new Api().post(`/views/digital-styling-upload/meta`, {
            orderId,
            files
        });
    }

    static deleteSingleImage(imageId: number): Promise<void> {
        return new Api().delete(`/views/digital-styling-upload/${imageId}`);
    }

    static deleteMultipleImages(images: CustomerOrSupportImage[]): Promise<void> {
        return new Api().post(`/views/digital-styling-upload/delete-multiple`, {
            images
        });
    }

    static deleteFailedUploadImage(imageId: number): Promise<any> {
        return new Api().delete(`/views/digital-styling-upload/meta/${imageId}`);
    }

    static setImageInProgress(imageData: ImageUploadResponse): Promise<any> {
        return new Api().post(`/views/digital-styling-upload/unedited/in-progress`, {
            ...imageData
        });
    }

    static downloadImages(orderId: number): Promise<Response> {
        return new Api().get(`/views/digital-styling-upload/unedited/download/${orderId}`);
    }

    static deleteSingleCustomerImage(imageId: number) {
        return new Api().delete(`/views/digital-styling-upload/customer-files/${imageId}`);
    }
}
